// index.js
import Accordion from './Accordion';
import AccordionDetails from './AccordionDetails';
import AccordionSummary from './AccordionSummary';

export { Accordion, AccordionDetails, AccordionSummary };
